import React from 'react';
import {Trans, useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';

// Comments
import {Typography} from '@nur-portal/ui-kit';

import {LoginTracker} from '../../../../services/analytics/auth';
import Link from '../../../../website-ui/components/link';

// Styles
import styles from './article-preview.module.css';

const LOGIN_LINK_URL = `${window.location.origin}/login?redirectURL=${window.location.pathname}`;

const CommentAreaHeader = ({commentsCount, isUserAuthenticated}) => {
  const {t} = useTranslation();
  const areThereAnyComments = commentsCount >= 1;

  const handleAuthButtonClick = () => {
    LoginTracker.fromCommentsPreview();
  };

  return (
    <div className={styles.header}>
      <div className={styles.headerText}>
        <Typography
          variant='title-21'
        >
          {areThereAnyComments
            ? t('articleComments.lastComments')
            : t('articleComments.noComments')
          }
        </Typography>
        {areThereAnyComments ? (
          <Typography
            className={styles.secondaryText}
            variant='title-17'
          >
            {`${t('articleComments.commentsCount')} ${commentsCount}`}
          </Typography>
        ) : null}
      </div>
      {!isUserAuthenticated && (
        <div className={styles.greyArea}>
          <Typography
            variant='text-14'
          >
            <Trans
              i18nKey="articleComments.notAuthenticatedText"
              components={{
                text: (
                  <Link
                    href={LOGIN_LINK_URL}
                    onClick={handleAuthButtonClick}
                    className={styles.linkText}
                    rel="nofollow"
                  />)
              }}
            />
          </Typography>
        </div>
      )}
    </div>
  );
};

CommentAreaHeader.propTypes = {
  commentsCount: PropTypes.number.isRequired,
  isUserAuthenticated: PropTypes.bool.isRequired
};

export default CommentAreaHeader;
